import React from 'react'
import map from 'lodash/map'
import findIndex from 'lodash/findIndex'
import MultiselectionDropdown from '@SiteComponents/MultiselectionDropdown'
import '@SiteComponents/SearchDropdown/SearchDropdown.scss'
import './LanguageSelection.scss'


interface LanguageSelectionProps {
  readonly selectedLanguages: string[]
  readonly availableLanguages: string[]
  setSelectedLanguages(newSelectedLanguages: string[]): void
}

const LanguageSelection: React.FC<LanguageSelectionProps> = props => {
  const {
    selectedLanguages,
    availableLanguages,
  } = props

  const selectedLanguagesIndices = map(selectedLanguages, selectedLanguage => findIndex(availableLanguages, availableLanguage => availableLanguage === selectedLanguage))

  const setSelectedLanguageIndices = (newSelectedLanguageIndices: number[]) => {
    const newSelectedLanguages = map(newSelectedLanguageIndices, newSelectedLanguageIndex => availableLanguages[newSelectedLanguageIndex])
    props.setSelectedLanguages(newSelectedLanguages)
  }

  const renderLanguagesDropdown = () => {
    return (
      <MultiselectionDropdown
        availableOptions={availableLanguages}
        selectedOptionIndices={selectedLanguagesIndices}
        entityName="language"
        classNameForClickOutsideListener="LanguageSelection__dropdown"
        classNameOfContainerToMakeUnscrollable="ExportationPopup"
        setSelectedOptionIndices={setSelectedLanguageIndices}
        disabled={availableLanguages.length === 0}
        idNameOfParentContainer="language-selection"
        isForExportation
        showAllCounter
      />
    )
  }

  return (
    <div
      className="LanguageSelection"
      id="language-selection"
    >
      {renderLanguagesDropdown()}
    </div>
  )
}

export default LanguageSelection
